import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuthStore } from 'state/store/auth/useAuthStore';
import { LoadingOverlay } from 'components/core/loading-overlay';
import { useConfig } from 'hooks/use-config';
import { getOidcRuntimeEnv } from 'lib/runtime-env';

export function SigninOidcCallbackPage() {
  const [searchParams] = useSearchParams();
  const { setAuthenticated } = useAuthStore();
  const hasProcessed = useRef(false);
  const { configurationSettings } = useConfig();

  const code = searchParams.get('code');
  const state = searchParams.get('state');
  const error = searchParams.get('error');
  const tenantId = searchParams.get('tenant_id') || process.env.REACT_APP_PUBLIC_BLOCKS_KEY;

  useEffect(() => {
    if (hasProcessed.current || !configurationSettings) {
      return;
    }

    hasProcessed.current = true;

    (async () => {
      const oidcEnv = getOidcRuntimeEnv(configurationSettings.paths.baseUrl);
      const callbackUrl = new URL(`${oidcEnv.idpBaseUrl.replace(/\/$/, '')}/iam/v4/idp/callback`);
      if (code) callbackUrl.searchParams.set('code', code);
      if (state) callbackUrl.searchParams.set('state', state);
      if (error) callbackUrl.searchParams.set('error', error);
      if (tenantId) callbackUrl.searchParams.set('tenant_id', tenantId);

      const headers: Record<string, string> = {};
      if (tenantId) {
        headers['X-Blocks-Key'] = tenantId;
      }
      console.log('[OIDC] Callback URL:', callbackUrl.toString());

      fetch(callbackUrl.toString(), { headers, credentials: 'include' })
        .then((response) => {
          if (!response.ok) {
            window.location.href = '/login?error=callback_failed';
            return;
          }

          setAuthenticated();
          window.location.href = '/';
        })
        .catch(() => {
          window.location.href = '/login?error=callback_error';
        });
    })();
  }, [code, configurationSettings, error, setAuthenticated, state, tenantId]);

  return <LoadingOverlay />;
}
